import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { useContent } from "@/context/ContentContext";
import { Bell } from "lucide-react";

export function StaffNotifBell() {
  const { t } = useContent();
  const [notifs, setNotifs] = useState([]);
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const load = () => api.get("/notifications").then((r) => setNotifs(r.data)).catch(() => {});
  useEffect(() => { load(); const id = setInterval(load, 60000); return () => clearInterval(id); }, []);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setShow(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  const unread = notifs.filter((n) => !n.read).length;
  const open = async () => { setShow((v) => !v); if (unread) { await api.post("/notifications/read").catch(() => {}); load(); } };
  return (
    <div className="relative" ref={ref}>
      <button onClick={open} data-testid="staff-notif-btn" className="relative flex h-9 w-9 items-center justify-center rounded-full border border-slate-700 text-slate-200 hover:bg-slate-800">
        <Bell className="h-4 w-4" />
        {unread > 0 && <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-accent px-1 text-[9px] font-bold text-white" data-testid="staff-notif-count">{unread}</span>}
      </button>
      {show && (
        <div className="fixed left-4 right-4 top-[4.5rem] z-50 max-w-sm rounded-xl border border-slate-700 bg-slate-900 p-2 text-white shadow-xl sm:absolute sm:left-auto sm:right-0 sm:top-full sm:mt-2 sm:w-96" data-testid="staff-notif-panel">
          <div className="px-2 py-1.5 text-sm font-semibold">{t("client.notifs", "Notifications")}</div>
          <div className="max-h-80 overflow-auto">
            {!notifs.length && <div className="p-6 text-center text-sm text-slate-500">{t("client.no_notifs", "Aucune notification")}</div>}
            {notifs.slice(0, 15).map((n) => (
              <div key={n.id} className="rounded-lg p-2 hover:bg-slate-800">
                <div className="text-sm font-medium">{n.title}</div>
                <div className="break-words text-xs text-slate-400">{n.message}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
